<template>
    <div :class="{
        cell: true,
        'map-node': true,
        selected: node.selected,
        wide: isSelectedColumn,
        collapsed: x >= collapseRange[0] && x <= collapseRange[1]
    }"
        :data-node-id="node.nodeId">
        <div :class="{
            content: true,
            node: true,
            connected: nodeToTheRight && nodeToTheRight.connector,
            active: activePath
        }" v-if="node.title">
            <div style="cursor: pointer;" @click="clickNode">
                <div v-if="y > 0" :class="{
                    'v-up': true,
                    active: node.selected
                }" />
                <span><strong>{{ node.title }}</strong></span>
                <div class="steps">
                    <span v-for="(step, si) in node.checklist" :key="'step-' + node.id + '-' + si" :class="step.state" />
                </div>
                <div v-if="node.children && node.children.length > 0" :class="{
                    'v-down': true,
                    'active': anySelectedChildren
                }" />
                <div class="position" />
                <div :class="{
                    l: true,
                    active: nodeBelow && nodeBelow.selected
                }"></div>
                <div v-if="node.children && node.selectedChildIndex !== (node.children.length - 1)"
                    :class="{
                        r: true,
                        active: node.toTheRightSelected
                }"></div>
            </div>
        </div>
        <div :class="nodeClass" v-else-if="node.connector">
            <div :class="{
                    l: true,
                    active: nodeBelow && nodeBelow.selected
                }"></div>
            <div class="r"></div>
            <div class="v"></div>
        </div>
    </div>
</template>
<script>
// import velocity from 'velocity-animate';

export default {
    props: {
        x: {
            type: Number
        },
        y: {
            type: Number
        },
        grid: {
            type: Array
        },
        node: {
            type: Object
        },
        nodes: {
            type: Object
        },
        selectedColumns: {
            type: Array
        },
        selectedRows: {
            type: Array
        },
        activePath: {
            type: Boolean,
            default: false
        },
        collapseRange: {
            type: Array,
            default: function() { return [0, -1]; }
        },
        forceHConnector: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        nodeToTheRight() {
            let n;

            if (this.grid[this.y][this.x + 1]) {
                n = this.nodes[this.grid[this.y][this.x + 1]];
            } else {
                n = false;
            }
            return n;
        },
        nodeBelow() {
            let n;

            if ((this.grid.length > (this.y + 1)) && this.grid[this.y + 1][this.x]) {
                n = this.nodes[this.grid[this.y + 1][this.x]];
            } else {
                n = false;
            }
            return n;
        },
        belowConnectorCharacter() {
            let n = this.nodeToTheRight;
            if (n && n.connector) {
                return '+';
            } else {
                return '|';
            }
        },
        isSelectedColumn() {
            return this.selectedColumns.includes(this.x);
        },
        anySelectedChildren() {
            return this.node.children.reduce((s, n) => s || this.nodes[n.nodeId].selected, false);
        },
        nodeClass() {
            let c = ['node'];

            if (this.node.connector) {
                c.push('connector');
                if (this.nodeToTheRight && this.nodeToTheRight.connector || this.forceHConnector) {
                    c.push('h-connect');
                }
                if (this.nodeBelow && this.nodeBelow.connector === undefined && !this.forceHConnector) {
                    c.push('v-connect');
                }
            } else {
                c.push('empty');
            }
            if (this.activePath) {
                c.push('active');
            }
            return c;
        }
    },
    methods: {
        clickNode() {
            if (this.node.selected) {
                // @click="$emit('openSteps', node.nodeId, node.title, node.description)"
                this.$emit('openSteps', this.node.nodeId, this.node.title, this.node.description);

            } else {
                // @click="$emit('select')"
                this.$emit('select');
                // velocity(this.$el, 'scroll', { axis: 'x', delay: 333, offset: -100 });
                    // .then(() => velocity(this.$el, 'scroll', { axis: 'y' }));
            }
        }
    }
}
</script>